import { SDKManager } from '@flic-chat/js-sdk';
import socket from "./socket";

const FCManager = new SDKManager(socket, console);

export default FCManager;



// WEBPACK FOOTER //
// ./manager.js